import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppNotificationService {
  private containerRef?: ViewContainerRef;

  setNotificationContaier(container: ViewContainerRef): void {
    this.containerRef = container;
  }
  getNotificationContaier(): ViewContainerRef | undefined {
    return this.containerRef;
  }
}
